import get from 'lodash/get';

export const createMapEntityToOptions = (config = {}, t) => {
  const {keyLabel = 'name', keyValue = '_id'} = config;
  return item => {
    const value = get(item, keyValue);
    const label = get(item, keyLabel);
    return {value, label: t(`${label}`)};
  };
};